if(typeof BSS_B2B != undefined) {
    if(window.location.pathname.includes("/products")) {
      setTimeout(() =>{
          const targetProduct = document.querySelector('.installment-shoppay input[name="id"]');
        if (targetProduct) {
          const mutationObserver = new MutationObserver((recordList, observe) => {
            const productForm = document.querySelector("[bss-b2b-main-product-form]");
            BSS_B2B.observer.productSubject.notifyObserver('VariantChange', 'VariantSelectChange', {productForm});
          });
          mutationObserver.observe(targetProduct, { attributes: true });
        }
        
      }, 1000)
    }
}